import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { MapPin, Video } from 'lucide-react';

const LocationsSection: React.FC = () => {
  return (
    <section id="locations" className="section-padding bg-gradient-to-b from-amber-50 to-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="mb-4 bg-gradient-to-r from-sage-600 to-amber-500 bg-clip-text text-transparent">Our Locations</h2>
          <p className="max-w-3xl mx-auto text-lg text-gray-700">
            Visit us in Currimundi or connect online — compassionate women's wellness care on the Sunshine Coast.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* Currimundi Clinic */}
          <Card className="rounded-2xl shadow-lg border-2 border-amber-200/30 overflow-hidden hover:shadow-xl transition-all duration-300">
            <div className="bg-gradient-to-r from-sage-600 to-sage-700 p-6 text-white">
              <h3 className="text-2xl font-serif font-semibold mb-2">Currimundi Clinic</h3>
              <p className="text-sage-100">Your sanctuary for women's wellness</p>
            </div>
            <CardContent className="p-6">
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-sage-600 mt-1 flex-shrink-0" />
                  <div>
                    <p className="font-medium text-sage-800">700 Nicklin Way</p>
                    <p className="text-sage-600">Currimundi QLD 4551</p>
                  </div>
                </div>
                
                <p className="text-sage-700">
                  Our main clinic offering comprehensive Traditional Chinese Medicine consultations, acupuncture, and herbal medicine.
                </p>

                <div className="pt-4">
                  <Button 
                    asChild
                    className="w-full bg-amber-600 hover:bg-amber-700 text-white text-sm sm:text-base"
                  >
                    <a href="/currimundi-clinic">Learn More About Currimundi</a>
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Online Consultations */}
          <Card className="rounded-2xl shadow-lg border-2 border-amber-200/30 overflow-hidden hover:shadow-xl transition-all duration-300">
            <div className="bg-gradient-to-r from-sage-700 to-sage-800 p-6 text-white">
              <h3 className="text-2xl font-serif font-semibold mb-2">Online Consultations</h3>
              <p className="text-sage-100">Personalised care, wherever you are</p>
            </div>
            <CardContent className="p-6">
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <Video className="w-5 h-5 text-sage-600 mt-1 flex-shrink-0" />
                  <div>
                    <p className="font-medium text-sage-800">Australia-wide</p>
                    <p className="text-sage-600">Phone & video consults</p>
                  </div>
                </div>
                
                <p className="text-sage-700">
                  Receive Chinese medicine care, herbal prescriptions, and personalised support from anywhere in Australia.
                </p>

                <div className="pt-4">
                  <Button 
                    asChild
                    variant="outline"
                    className="w-full border-sage-600 text-sage-600 hover:bg-sage-600 hover:text-white text-sm sm:text-base"
                  >
                    <a href="/online-consultations">Learn More About Online Care</a>
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <div className="text-center mt-12">
          <p className="text-lg text-sage-700 mb-6">
            All our services offer the same high-quality care and compassionate approach to women's wellness.
          </p>
          <Button 
            asChild
            className="bg-sage-600 hover:bg-sage-700 text-white"
          >
            <a href="#contact">Contact Us for Appointments</a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default LocationsSection; 